
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/battery-backup-for-home",
      function () {
        return require("private-next-pages/battery-backup-for-home/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/battery-backup-for-home"])
      });
    }
  